import { render, staticRenderFns } from "./CardsArchive.vue?vue&type=template&id=55f3bd0c"
import script from "./CardsArchive.vue?vue&type=script&lang=js"
export * from "./CardsArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports